import './style/documentData.scss';

import {
    AwesomeIcon,
    ChangeFunction, Checkbox, CloseButton, DvrdButton, DvrdInput, ErrorType, FileUpload, Loader, WithBackground
} from '@dvrd/dvr-controls';
import React, {MouseEventHandler, useMemo} from 'react';
import Document from "../../../../models/documentModel";

interface Props {
    onClose: MouseEventHandler;
    onPickFile: (file: FileList) => void;
    onChangeLabel: ChangeFunction<string>;
    onChangeActive: ChangeFunction<boolean>;
    onSubmit: MouseEventHandler;
    onDeleteDocument: MouseEventHandler;
    document: Document;
    active: boolean;
    loading: boolean;
    error: ErrorType;
    file: File | null;
}

export default function DocumentData(props: Props) {
    const {
        onClose, onPickFile, onChangeLabel, onChangeActive, onSubmit, onDeleteDocument, document, active, loading,
        error, file
    } = props;
    const [title, submitAction] = useMemo(() => {
        if (document.id.length) return ['Document bijwerken', 'Opslaan'];
        return ['Document toevoegen', 'Uploaden'];
    }, [document.id]);

    function renderBody() {
        return (
            <div className='body-container'>
                <Loader active={loading}/>
                {!document.id.length ? <FileUpload file={file} onChange={onPickFile}/> :
                    <DvrdButton onClick={onDeleteDocument} label='Document verwijderen'
                                ornaments={{element: <AwesomeIcon name='trash-alt'/>}} className='btn-delete' red/>}
                <DvrdInput onChange={onChangeLabel} value={document.label} label='Documentnaam'
                           placeholder='Naam van het document'/>
                <Checkbox checked={document.active} onCheck={onChangeActive} label='Tonen op website'/>
                {!!error && <label className='error-label'>{error}</label>}
            </div>
        )
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='default-popup document-data'>
                <div className='header-container'>
                    <label className='header-title'>{title}</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <DvrdButton onClick={onClose} label='Sluiten' disabled={loading} secondary/>
                    <DvrdButton onClick={onSubmit} label={submitAction} disabled={loading}/>
                </div>
            </div>
        </WithBackground>
    )
}